import { apiService } from "./apiService";
import { endpoints } from "../config/endpoints";
import { pickBy } from "lodash";

export default {
  getBusinessAddressesData(payload) {
    const url = payload
      ? `${endpoints.businessAddresses}?order_by=${payload}`
      : endpoints.businessAddresses;

    return apiService.get(url);
  },

  getKeywords(addressId) {
    return apiService.get(
      `${endpoints.businessAddresses}${addressId}/keywords/`
    );
  },

  getKeywordData({ businessAddressId, keywordId }) {
    return apiService.get(
      `${endpoints.map}?address=${businessAddressId}&keyword=${keywordId}`
    );
  },

  postBusinessAddresses(businessAddress) {
    return apiService.post(endpoints.businessAddresses, businessAddress);
  },

  deleteBusinessAddress(businessAddressId) {
    return apiService.delete(
      `${endpoints.businessAddresses}${businessAddressId}/`
    );
  },

  getGoogleMyBusinessAudits({ businessAddressId }) {
    return apiService.get(
      `${endpoints.businessAddresses}${businessAddressId}/google-my-business-audits/last/`
    );
  },

  getGoogleMyBusinessAuditsHistory(id, { from, to }, type) {
    return apiService.get(
      `${endpoints.businessAddresses}${id}/google-my-business-audits/?created_at__gte=${from}&created_at__lt=${to}&fields=created_at,${type}`
    );
  },

  getCompetitionBusinessAddresses(businessAddressId) {
    return apiService.get(
      `${endpoints.businessAddresses}${businessAddressId}/business-address-competition/`
    );
  },

  postCompetitionBusinessAddress(businessAddressId, data) {
    return apiService.post(
      `${endpoints.businessAddresses}${businessAddressId}/business-address-competition/`,
      data
    );
  },

  getSuggestedBusinessAddresses(businessAddressId) {
    return apiService.get(
      `${endpoints.businessAddresses}${businessAddressId}/suggested-business-address-competition/`
    );
  },

  getCategoriesList({ page, perPage, query }) {
    const params = {
      page: page,
      page_size: perPage,
      name: query
    };
    return apiService.get(endpoints.categories, {
      params: pickBy(params)
    });
  },

  postSuggestedBusinessAddress(businessAddressId, data) {
    return apiService.post(
      `${endpoints.businessAddresses}${businessAddressId}/suggested-business-address-competition/`,
      data
    );
  },

  deleteCompetitionBusinessAddress(
    businessAddressId,
    competitionBusinessAddressId
  ) {
    return apiService.delete(
      `${endpoints.businessAddresses}${businessAddressId}/business-address-competition/${competitionBusinessAddressId}/`
    );
  },

  getMapsAudits(businessAddressId) {
    return apiService.get(
      `${endpoints.businessAddresses}${businessAddressId}/other-maps-audits/last/`
    );
  },

  getAvgMapSearchResult({ address, keyword }, { from, to }) {
    return apiService.get(
      `${endpoints.avgMapSearchResult}?address=${address}&keyword=${keyword}&searched_at__gte=${from}&searched_at__lte=${to}`
    );
  }
};
